import type { FC, ReactNode } from 'react'

import { useEffect, useRef } from 'react'
import { subscribeFrame } from '@/lib/universe/store'

// How far the camera is from the event horizon, in horizon radii
export const DistanceReadout: FC = (): ReactNode => {
    const valueRef = useRef<HTMLSpanElement>(null)

    useEffect(() => {
        let last = ''

        return subscribeFrame(frame => {
            const node = valueRef.current

            if (!node) return

            const distance = frame.params.distance * (1 - 0.07 * frame.boost) - 1
            const text = `${Math.max(0, distance).toFixed(1)} R`

            if (text !== last) {
                node.textContent = text
                last = text
            }
        })
    }, [])

    return (
        <div aria-hidden='true' className='pointer-events-none fixed inset-x-0 bottom-3 z-40 flex justify-center md:bottom-4'>
            <p className='mono-note flex items-center gap-3 text-[0.625rem] lowercase text-muted-foreground'>
                <span>
                    distance from horizon
                </span>

                <span ref={valueRef} className='min-w-[4.5em] tabular-nums text-flare/90'>
                    16.0 R
                </span>
            </p>
        </div>
    )
}
